import { NgModule } from "@angular/core";
import { CoreModule } from "@modules/core/core.module";
import { SharePreviewComponent } from "@modules/social-trading/components/share-preview/share-preview.component";
import { ShareGraphComponent } from "@modules/social-trading/components/share-graph/share-graph.component";
import { ChartModule } from "@modules/shared/chart/chart.module";

const components = [SharePreviewComponent, ShareGraphComponent];

@NgModule({
	imports: [CoreModule, ChartModule],
	declarations: [...components],
	exports: [...components]
})
export class SocialTradingModule {}
